import { c as _c } from "react/compiler-runtime";
import React from "react";
const GreenCheck = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"><path fillRule="evenodd" clipRule="evenodd" d="M12.0045 1.5061C17.8025 1.5061 22.5045 6.20816 22.5045 12.0062C22.5045 17.8042 17.8025 22.5062 12.0045 22.5062C6.20645 22.5062 1.50439 17.8042 1.50439 12.0062C1.50439 6.20816 6.20645 1.5061 12.0045 1.5061ZM9.82399 15.4167L7.25332 12.8439C6.81536 12.4057 6.81527 11.691 7.25332 11.2529C7.69145 10.8149 8.40923 10.8176 8.84418 11.2529L10.6565 13.0667L15.1649 8.55824C15.603 8.12011 16.3177 8.12011 16.7558 8.55824C17.1939 8.99628 17.1933 9.71159 16.7558 10.1491L11.4506 15.4542C11.0131 15.8917 10.2978 15.8924 9.85977 15.4542C9.84746 15.4419 9.83559 15.4294 9.82399 15.4167Z" fill="#00BA00" /></svg></>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};
export default GreenCheck;